/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Lead } from './Lead';
import {
    LeadFromJSON,
    LeadFromJSONTyped,
    LeadToJSON,
} from './Lead';

/**
 * 
 * @export
 * @interface FindHospitalizedInstances200Response
 */
export interface FindHospitalizedInstances200Response {
    /**
     * 
     * @type {Array<Lead>}
     * @memberof FindHospitalizedInstances200Response
     */
    data?: Array<Lead>;
}

/**
 * Check if a given object implements the FindHospitalizedInstances200Response interface.
 */
export function instanceOfFindHospitalizedInstances200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindHospitalizedInstances200ResponseFromJSON(json: any): FindHospitalizedInstances200Response {
    return FindHospitalizedInstances200ResponseFromJSONTyped(json, false);
}

export function FindHospitalizedInstances200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindHospitalizedInstances200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(LeadFromJSON)),
    };
}

export function FindHospitalizedInstances200ResponseToJSON(value?: FindHospitalizedInstances200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(LeadToJSON)),
    };
}

